// The handover search samples the pressure profile on a grid of front positions (plus every node),
// then bisects the last crossing. The profile is piecewise linear between nodes and kinks where an
// intermediate node clamps to zero, so a peak can hide between samples; the grid bounds that error.
export const FLUSH_SCAN_DIVISIONS = 400;
export const FLUSH_SCAN_MIN_STEP_METRES = 0.5;
export const FLUSH_BISECTION_STEPS = 40;

// Water volumes within this fraction of the line volume count as reaching the stope.
export const FLUSH_VOLUME_TOLERANCE = 1e-9;
